import styled from 'styled-components';

export const DangerLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 0 0;
  background: transparent;
  border: none;
  color: #b91c1c;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  align-self: flex-start;
  transition: color 0.15s ease;

  &:hover {
    color: #7f1d1d;
    text-decoration: underline;
  }
`;
